
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lnat/dashboard",
      function () {
        return require("private-next-pages/lnat/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lnat/dashboard"])
      });
    }
  